import React from 'react';
import Helmet from 'react-helmet';
import { StaticQuery, graphql } from 'gatsby';
import Header from '../components/header';
import Footer from '../components/footer';
// import Provider from '../context/provider';
// import './reset.scss';
// import './base.scss';
// import './layout.sass';
import './header.scss';
import './footer.scss';
import './page.scss';
import './sub.scss';

const Layout = ({ children }) => {
  return (
    <>
      <Helmet>
        {/* <link
          rel="stylesheet"
          href="https://cdnjs.cloudflare.com/ajax/libs/slick-carousel/1.3.15/slick.css"
        /> */}
        {/* <script src="https://ajax.googleapis.com/ajax/libs/jquery/1.11.2/jquery.min.js"></script> */}
        {/* <script src="https://cdnjs.cloudflare.com/ajax/libs/gsap/3.5.1/gsap.min.js"></script> */}
        {/* <script src="https://cdnjs.cloudflare.com/ajax/libs/gsap/3.5.1/ScrollTrigger.min.js"></script> */}
        {/* <script src="https://cdnjs.cloudflare.com/ajax/libs/ScrollMagic/2.0.8/ScrollMagic.min.js"></script> */}
        {/* <script src="https://cdnjs.cloudflare.com/ajax/libs/ScrollMagic/2.0.7/plugins/animation.gsap.min.js"></script> */}
        {/* <script src="https://cdnjs.cloudflare.com/ajax/libs/gsap/1.19.1/TweenMax.min.js"></script> */}
        {/* <script src="https://cdnjs.cloudflare.com/ajax/libs/slick-carousel/1.3.15/slick.js"></script> */}
      </Helmet>
      <StaticQuery
        query={graphql`
          query SiteTitleQuery {
            site {
              siteMetadata {
                title
              }
            }
          }
        `}
        render={(data) => (
          <>
            <Header siteTitle={data.site.siteMetadata.title} />
            {children}
            <Footer />
          </>
        )}
      />
    </>
  );
};

export default Layout;
